import styled from 'styled-components';
import { WRAPPER } from '@/shared/styles/themes';

export const ProfileWrapper = styled.div`
  ${WRAPPER};
  display: flex;
  gap: 24px;
`;
export const ProfileContainer = styled.div`
  border-top: 1px solid #1b202d;
  padding-top: 20px;

  @media (max-width: 768px) {
    padding-top: 0;
  }
`;

export const SidebarWrapper = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;
export const MobileMenuWrapper = styled.div`
  @media (orientation: portrait) {
    /* padding-bottom: 50px; */
  }
  @media (max-width: 1024px) and (orientation: landscape) {
    //padding-right: 50px;
    width: 100%;
    display: flex;
    flex-direction: column;
    height: 100dvh;
  }
  ${({ $flexMain }) =>
    $flexMain &&
    `
      display: flex;
      flex-direction: column;
      height: 100dvh;
      padding-right: 0;
      box-sizing: border-box;
    `};

  //@media (orientation: landscape) {
  //  padding-right: 0;
  //}
`;
export const ContentWrapper = styled.div`
  @media (orientation: portrait) {
    //padding-bottom: 50px;

    ${({ $withoutMenu }) =>
      $withoutMenu &&
      `
    padding-bottom: 0;
  `}
  }
  @media (max-width: 1024px) and (orientation: landscape) {
    width: 100%;

    display: flex;
    flex-direction: column;
    height: 100%;
  }
  ${({ $flexMain }) =>
    $flexMain &&
    `
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 0;
    `}
`;
export const UnderHeaderWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  overflow-y: hidden;

  @media (orientation: landscape) {
    flex-direction: row-reverse;
    //height: 100%;
    min-height: 266px;
    justify-content: flex-end;
    flex: 1;
  }
  @media (orientation: portrait) {
    flex-direction: column;
    flex: 1;
  }
`;
export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;

  @media (min-width: 769px) {
    padding: 0 18px;
  }
`;
export const MainWrapper = styled.main`
  overflow-y: auto;

  @media (max-width: 1024px) and (orientation: landscape) {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    align-items: center;
    flex: none;
  }

  ${({ $flexMain }) =>
    $flexMain &&
    `
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1;
    width: 100%;
    align-items: center;
  `}
`;
